import { useCommonReducer } from '@components/Shared/State/hooks';
const useMobileActiveMenu = () => useCommonReducer('MOBILE_ACTIVE_MENU', {
    activePath: null,
});
export default useMobileActiveMenu;
